import React from 'react';
import { ButtonGroup } from '../../../Common/styled/Button';
import { CommonButtons, AcknowledgeButton, LogoutButton } from '../../../Header/Toolbar/ToolbarButtons';

export const toolbarVoid = ({ layout, config }) => (
  <ButtonGroup key="group">
    <CommonButtons config={config} layout={layout}/>
    <AcknowledgeButton config={config} />
    <LogoutButton />
  </ButtonGroup>
);
